import React from "react";
import { Link } from "react-router-dom";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { LiaReplyAllSolid } from "react-icons/lia";
import { formatMessengerTime } from "../../../Utils/formatMessengerTime/formatMessengerTime";
import { FaRegEye } from "react-icons/fa";

import { HiOutlineEyeSlash } from "react-icons/hi2";

const SingleItem = ({
    data,
    typingInfo,
    onlineUsers,
    adminTypingInfo,
    adminData
}) => {

    const isTyping = typingInfo?.includes(data?.email);
    const OnlineUsersStatus = onlineUsers?.some(
        (u) => u?.email?.toLowerCase() === data?.email?.toLowerCase()
    );

    const adminTypingStatus = adminTypingInfo?.find(
        (t) => t?.userEmail?.toLowerCase() === data?.email?.toLowerCase()
    );



    const getMessagePreview = (html, limit = 10) => {
        if (!html) return "";

        const temp = document.createElement("div");
        temp.innerHTML = html;

        const text = temp.textContent || temp.innerText || "";

        return text.length > limit
            ? text.substring(0, limit) + "..."
            : text;
    };

    return (
        <>

            {/* live-chat User */}
            <Link to={`/message/${data?._id}/?path=chats`}>

                <div className="live-chat-user-card">

                    <div className="live-chat-user-profile">

                        <div className="live-chat-profile-icon">
                            <span><img src={
                                data?.picture
                                    ? `${process.env.REACT_APP_Authorized_API_URL}/${data?.picture}`
                                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                            }
                                onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")} alt="profile" /></span>
                        </div>

                        <span className={`live-chat-online-dot  ${OnlineUsersStatus ? "" : "live-chat-offline-dot"} me-2`} ></span>

                    </div>


                    <div className="live-chat-user-info">
                        <p className="live-chat-user-name">
                            {data?.fname} {data?.lname}
                            {
                                parseInt(data?.unseenCount) > 0 && (<span>{data?.unseenCount}</span>)
                            }
                        </p>

                        <p className="live-chat-user-company typing-dot">
                            {isTyping ? (
                                <>
                                    is typing <span className="dot"></span><span className="dot"></span><span className="dot"></span>
                                </>
                            ) : (
                                <>
                                    {adminTypingStatus && adminData && (
                                        <>
                                            typing by  {adminData?.name} <span className="dot"></span><span className="dot"></span><span className="dot"></span>
                                        </>
                                    )}

                                    {data?.lastMessage && !adminTypingStatus && !isTyping && (
                                        <>
                                            {data?.lastMessage?.images?.length > 0
                                                ? "file send"
                                                :
                                                getMessagePreview(data?.lastMessage?.text, 10)
                                            }

                                            {data?.lastMessage?.adminId ? (
                                                <LiaReplyAllSolid className="ms-2 admin-message-send-icon" />
                                            ) : (
                                                <LiaReplyAllSolid className="ms-2" />
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            {/* {data?.lastMessage && (
                                <span className="time">{formatMessengerTime(data?.lastMessage?.createdAt)}</span>
                            )} */}


                            {/* WLF Mobile Chat */}
                        </p>
                    </div>


                    <button className="live-chat-hide-btn">
                        {
                            parseInt(data?.unseenCount) > 0 ? <HiOutlineEyeSlash /> : <FaRegEye />
                        }

                    </button>

                </div>

            </Link>

        </>
    );
};

export default SingleItem;
